import React, { Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'

window['global'] = window
import { ChatScreenSkeleton } from 'common/UI/LoadingSkeleton'
import { ThemeProvider } from 'common/contexts/themeContext/themeContext'
import ErrorBoundary from 'common/UI/ErrorBoundary'
import { lazyWithErrorHandling } from 'modules/Auth/store/lazy'
import { ContentBlock } from 'common/UI/ContentBlock'
import { initAnalytics } from 'lib/trackEvent'
// import ShutDown from 'modules/Auth/ShutDown'

import styles from './App.module.scss'

// Initialize PostHog BEFORE the first render. Previously analytics init ran
// from App.jsx behind the async getHostInfo() call plus a lazy chunk import, so
// the login/create-account page mounted and fired auth_login_visit BEFORE
// posthog.init() — the event hit an uninitialized PostHog and was dropped
// (0 login-visits on dev, heavy undercount in prod). posthog.init only needs
// `config` (derived from the hostname/env), never host info, so running it here
// guarantees PostHog is ready for the very first event on the very first page.
initAnalytics()

const App = lazyWithErrorHandling(() => import('./App'))

const ErrorCatcher = () => {
  return (
    <HelmetProvider>
      <ErrorBoundary componentName="MainApp">
        <App />
        {/* <ShutDown /> */}
      </ErrorBoundary>
    </HelmetProvider>
  )
}

const container = document.getElementById('root')
const root = createRoot(container)
root.render(
  <Suspense
    fallback={
      <ContentBlock className={styles.themeWrapper}>
        <ChatScreenSkeleton />
      </ContentBlock>
    }
  >
    <ThemeProvider>
      <ErrorCatcher />
    </ThemeProvider>
  </Suspense>
)
